<template>
  <van-overlay show z-index="1000">
    <div class="overlay-wrapper" @click.stop>
      <div class="w-full box-border px-10">
        <div class="block box-border rounded-medium text-center w-full relative">
          <div class="close" v-if="showClose">
            <van-icon name="cross" size="24px" @click="onClose" />
          </div>
          <div class="text-theme-black-850">{{ message }}</div>
          <img :src="url" width="200" height="200" @load="onLoad" :alt="altText" />
          <div class="text-theme-black-450 text-medium" v-if="imgLoad">长按二维码进入公众号</div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'OverlayQrCode',
  props: {
    url: String,
    message: {
      type: String,
      default: '只有公众号粉丝可作答'
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgLoad: false,
      altText: process.env.NODE_ENV === 'development' ? '请搜索优数调研家公众号' : '请搜索调研工厂公众号'
    }
  },
  methods: {
    onLoad() {
      this.imgLoad = true
      console.log('img load')
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay-wrapper {
  .close {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .block {
    padding: 30px 24px;
  }
}
</style>
